export default __webpack_public_path__ + "static/events-light-fb5079afed1accb79009195dbad60929.png";